import { useParams } from "react-router-dom";

import { GameReport } from "./components/GameReport";

export default function GameReportRoute() {
    const { gameId } = useParams<{ gameId: string }>();

    if (!gameId) {
        return null;
    }

    return <GameReport gameId={gameId} />;
}
